import {emptyValidator, formValidator} from "../../validators";
const shiftUserAssignValidationStatus = {
    sduUser: {
        validators: [emptyValidator()],
        name: "User",
    },
    sduStatus: {
        validators: [emptyValidator()],
        name: "Status",
    },
    sduActive: {
        validators: [emptyValidator()],
        name: "Active",
    },
}

export const shiftUserAssignValidation = (shiftGroup) => {
    return formValidator(shiftGroup, shiftUserAssignValidationStatus);
};


const shiftStkAssignValidationStatus ={
    sdsStakeholder: {
        validators: [emptyValidator()],
        name: "Stakeholder",
    },
    sdsStatus: {
        validators: [emptyValidator()],
        name: "Status",
    },
    sdsActive: {
        validators: [emptyValidator()],
        name: "Active",
    },
}

export const shiftStkAssignValidation = (shiftGroup) => {
    return formValidator(shiftGroup, shiftStkAssignValidationStatus);
};

const shiftAssignValidationStatus = {
    sfhShift: {
        validators: [emptyValidator()],
        name: "Shift",
    },
    sfhDateStart: {
        validators: [emptyValidator()],
        name: "Start Date",
    },
    sfhDateEnd: {
        validators: [emptyValidator()],
        name: "End Date",
    },
    sfhStatus: {
        validators: [emptyValidator()],
        name: "Status",
    },
    sfhActive: {
        validators: [emptyValidator()],
        name: "Active",
    },
}


export const shiftAssignValidation = (shiftGroup) => {
    return formValidator(shiftGroup, shiftAssignValidationStatus);
};

const shiftActionAssignValidationStatus = {
    sdsActionStatus: {
        validators: [emptyValidator()],
        name: "Actions",
    },
}

export const shiftActionAssignValidation = (shiftGroup) => {
    return formValidator(shiftGroup, shiftActionAssignValidationStatus);
};
